import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PershingModalService } from '../services/pershing-modal.service';
import { LogService } from '@pershing/pershing-core';

/**
 * @desc NxpModalComponent is used primarily to open a dialog with a dynamic component
 */
@Component({
    selector: 'pershing-modal',
    template: `<ng-container></ng-container>`
})

export class PershingModalComponent implements OnInit, OnDestroy {
    /** holds the modal service subsription */
    private modalServiceSubscription: any;
    constructor(private pershingModalService: PershingModalService, private dialog: MatDialog,
                private logService: LogService) {
        let dialogRef: MatDialogRef<any>;
        this.modalServiceSubscription = this.pershingModalService.modalProperties$.subscribe(property => {
            // console.log('Subscription called for : ' + property.component);
            try {
                let defaultModalConfig: any = {
                    disableClose: property.modalConfig.disableClose,
                    panelClass: property.modalConfig.panelClass,
                    height: property.modalConfig.height,
                    maxHeight: property.modalConfig.maxHeight,
                    width: property.modalConfig.width,
                    maxWidth: property.modalConfig.maxWidth,
                    autoFocus: property.modalConfig.autoFocus,
                    id: property.modalConfig.modalId
                };

                if (property.modalConfig.data) {
                    defaultModalConfig.data = property.modalConfig.data;
                }
                dialogRef = this.dialog.open(property.component, defaultModalConfig);
                this.pershingModalService.dialogRef = dialogRef;
            } catch (e) {
                logService.error(e);
                return property; // handling any exception
            }
        });
    }

    ngOnInit() { }

    ngOnDestroy() {
        this.modalServiceSubscription.unsubscribe();
    }
}
